import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Slider } from "antd";
import { useCallback } from "react";
import { EMetaStatus } from "../../../interfaces";
import useMeta from "./useMeta";
import { validaDigitaçãoEFormataDinheiroBR } from "../../../../../utils/Conversores";
import Loading from "../../../../../components/Loading";

import { ptBR as portugues } from '@mui/x-date-pickers/locales';
// import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ptBR } from "date-fns/locale/pt-BR";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";

interface IParamsModalForm {
    isModalOpen: boolean;
    handleCancel: () => void;
    isLoading: boolean;
    isEditar: boolean;
    metaUuid: string | undefined;
    eixoUuid: string;
}

export const ModalFormMeta = ({ isModalOpen, handleCancel, isLoading, isEditar, metaUuid, eixoUuid }: IParamsModalForm) => {

    const {
        prioridadeSelecionada,
        statusSelecionado,
        handleSetPrioridade,
        onChangeSliderValue,
        inputSliderValue,
        handleSetStatus,
        onClickSalvarMeta,
        formMeta,
        refFormMeta,
        isLoadingModal,
        visibleDatePicker,
        onVisibleDatePicker,
        defaultValueDatePicker,
    } = useMeta(isModalOpen, metaUuid, handleCancel, eixoUuid);


    const buttonOptionPrioridade = useCallback((title: string, color: string) => {
        return (<Button style={{
            backgroundColor: prioridadeSelecionada === title ? color : "transparent",
            borderColor: color,
            borderBottomWidth: 3,
            borderRadius: 3,
            flex: 1,
            marginLeft: 6,
            color: prioridadeSelecionada === title ? "#fff" : color,
        }} type="primary"
            onClick={() => handleSetPrioridade(title)}
        >
            {title}
        </Button>)
    }, [prioridadeSelecionada]);

    const buttonOptionStatus = useCallback((title: EMetaStatus, color: string) => {
        return (<Button style={{
            backgroundColor: statusSelecionado === title ? color : "transparent",
            borderColor: color,
            borderBottomWidth: 3,
            borderRadius: 3,
            flex: 1,
            marginBottom: 8,
            marginLeft: 6,
            color: statusSelecionado === title ? "#fff" : color,
        }} type="primary"
            onClick={() => handleSetStatus(title)}
        >
            {title}
        </Button>)
    }, [statusSelecionado]);


    return (
        <Modal
            title={isEditar ? "Editar Meta" : "Adicionar Meta"}
            width={1000}
            footer={[]}
            open={isModalOpen}
            onOk={handleCancel}
            onCancel={handleCancel}
            destroyOnClose
        >
            <Form
                form={formMeta}
                ref={refFormMeta}
                name="formMeta"
                layout="vertical"
                onFinishFailed={() => { }}
            >
                <Loading loading={isLoading || isLoadingModal}>
                    <Row gutter={16} style={{ marginTop: 20 }}>
                        <Col hidden>
                            <Form.Item
                                name="uuid"
                                label="uuid">
                                <Input placeholder="uuid" disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="descricao"
                                label="Ação a ser realizada"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor preencha a descrição da meta!",
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    placeholder="Informe a descrição da meta"
                                    style={{ maxHeight: 150, height: 20 }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="objetivo"
                                label="Objetivo"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            "Por favor preencha o objetivo!",
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    placeholder="Informe o objetivo da meta"
                                    style={{ maxHeight: 150, height: 25 }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col hidden>
                            <Form.Item
                                name="eixoUuid"
                                label="eixoUuid"
                            >
                                <Input placeholder="eixoUuid" disabled />
                            </Form.Item>
                        </Col>
                        <Col span={15}>
                            <Row gutter={[8, 0]}>
                                <Col span={24} >
                                    <Form.Item
                                        name="responsavel"
                                        label="Responsável por esta meta"
                                    >
                                        <Input placeholder="Ex: Secretaria de saúde" />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        name="impactoSocial"
                                        label="Impacto social"
                                    >
                                        <Input placeholder="Ex: Aumentar a qualidade de saúde" />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Row gutter={16}>
                                        <Col span={10}>

                                            <Form.Item
                                                name="dataPrevistaConclusao"
                                                label="Data prevista para conclusão"
                                            >
                                                <DatePicker
                                                    style={{
                                                        width: '100%'
                                                    }}
                                                    format={{
                                                        format: 'DD/MM/YYYY',
                                                        type: 'mask',
                                                    }}
                                                    picker='date'
                                                    showTime
                                                    onClick={() => {
                                                        onVisibleDatePicker(true)
                                                    }}
                                                    popupStyle={{
                                                        display: 'none'
                                                    }}
                                                    panelRender={() => (
                                                        <LocalizationProvider
                                                            adapterLocale={ptBR}
                                                            localeText={portugues.components.MuiLocalizationProvider.defaultProps.localeText}
                                                            dateAdapter={AdapterDateFns}
                                                        >
                                                            <MobileDatePicker
                                                                // localeText={{}}
                                                                open={visibleDatePicker}
                                                                onClose={() => {
                                                                    onVisibleDatePicker(false)
                                                                }}
                                                                onAccept={(value) => {
                                                                    refFormMeta.current?.setFieldsValue(
                                                                        { dataPrevistaConclusao: dayjs(value), }
                                                                    );
                                                                }}
                                                                defaultValue={defaultValueDatePicker}
                                                                // ampmInClock={false}
                                                                // ampm={false}
                                                                autoFocus
                                                                // format="dd/MM/yyyy HH:mm"
                                                                format="dd/MM/yyyy"
                                                            />
                                                        </LocalizationProvider>
                                                    )}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={7}>
                                            <Form.Item
                                                name="valorEstimado"
                                                label="Valor estimado (R$)"
                                            >
                                                <Input
                                                    autoComplete="off"
                                                    prefix="R$"
                                                    onChange={(e) => {
                                                        refFormMeta.current.setFieldsValue(
                                                            { valorEstimado: validaDigitaçãoEFormataDinheiroBR(e.target.value) }
                                                        );
                                                    }}
                                                    placeholder="0,00"
                                                    maxLength={21}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={7}>
                                            <Form.Item
                                                name="valorGasto"
                                                label="Valor gasto (R$)"
                                            >
                                                <Input
                                                    autoComplete="off"
                                                    prefix="R$"
                                                    onChange={(e) => {
                                                        refFormMeta.current.setFieldsValue(
                                                            { valorGasto: validaDigitaçãoEFormataDinheiroBR(e.target.value) }
                                                        );
                                                    }}
                                                    placeholder="0,00"
                                                    maxLength={21}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        name="observacoes"
                                        label="Observações"
                                    >
                                        <Input.TextArea
                                            style={{ maxHeight: 150, height: 20 }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={9}>
                            <Row gutter={[0, 0]}>
                                <Col span={24}>
                                    <Form.Item
                                        name="prioridade"
                                        label="Prioridade"
                                    >
                                        <Input hidden value={prioridadeSelecionada} />
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}>
                                            {buttonOptionPrioridade('Baixa', '#2D9CDB')}
                                            {buttonOptionPrioridade('Normal', 'green')}
                                            {buttonOptionPrioridade('Alta', 'red')}
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        name="status"
                                        label="Status da meta"
                                    >
                                        <Input hidden value={statusSelecionado} />
                                        <div style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}>
                                            {buttonOptionStatus(EMetaStatus.PENDENTE, '#FFAF00')}
                                            {buttonOptionStatus(EMetaStatus.EM_ANDAMENTO, '#478CCF')}
                                            {buttonOptionStatus(EMetaStatus.EM_REANALISE, '#EB5B00')}
                                            {buttonOptionStatus(EMetaStatus.CONCLUIDO, '#2c7865')}
                                            {buttonOptionStatus(EMetaStatus.CANCELADO, '#C80036')}
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        name="porcentagemConclusao"
                                        label="Porcentagem de conclusão"
                                    >
                                        <Row gutter={8}>
                                            <Col span={17}>
                                                <Slider max={100} min={0}
                                                    onChange={onChangeSliderValue}
                                                    value={typeof inputSliderValue === 'number' ? inputSliderValue : 0}
                                                    tooltip={{
                                                        placement: "bottom",
                                                    }} />
                                            </Col>
                                            <Col>
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    value={inputSliderValue}
                                                    suffix='%'
                                                    onChange={onChangeSliderValue}
                                                />
                                            </Col>
                                        </Row>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Loading >

                <Row>
                    <Col span={24} style={{ textAlign: "end" }}>
                        <Button
                            style={{ marginRight: 10 }}
                            loading={isLoading || isLoadingModal}
                            onClick={handleCancel}
                        >
                            Cancelar
                        </Button>
                        {isEditar ? (
                            <Button
                                type="primary"
                                loading={isLoading || isLoadingModal}
                                onClick={onClickSalvarMeta}
                            >
                                Atualizar
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                loading={isLoading || isLoadingModal}
                                onClick={() => onClickSalvarMeta()}
                            >
                                Salvar
                            </Button>
                        )}
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
